import styled from '@emotion/styled';
import { CSSProperties } from 'react';

import { getCSSProperties } from '../../utils';

export type StackDirection = 'row' | 'column';

export const STACK_DIRECTION = {
  ROW: 'row',
  COLUMN: 'columns',
};

export type StackProps = {
  direction?: StackDirection;
  spacing?: number;
} & Omit<CSSProperties, 'direction'>;

export const Stack = styled.div<StackProps>(
  ({ direction = 'column', spacing = 0, ...rest }) => ({
    display: 'flex',
    flexDirection: direction,
    gap: `${spacing * 0.5}rem`,
    ...getCSSProperties(rest),
  })
);
